module.exports = __webpack_public_path__ + "aw.9301ec6e1c79c68003a0.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/aw.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/aw.svg
// module chunks = styles